import type { User } from '@/types/user';
import { apiFetch } from '@/lib/api';

export class AuthService {
  // Registration method removed - account creation is disabled
  
  async login(input: { email: string; password: string; rememberMe?: boolean }): Promise<User> {
    const res = await apiFetch(`/api/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      skipRefresh: true,
      body: JSON.stringify(input),
    });
    if (!res.ok) throw new Error('Login failed');
    const data = await res.json();
    return data.data as User;
  }

  async logout(): Promise<void> {
    const res = await apiFetch(`/api/auth/logout`, { method: 'POST', skipRefresh: true });
    if (!res.ok) throw new Error('Logout failed');
  }

  async refresh(): Promise<User> {
    const res = await apiFetch(`/api/auth/refresh`, { method: 'POST', skipRefresh: true });
    if (!res.ok) throw new Error('Refresh failed');
    const data = await res.json();
    return data.data as User;
  }

  async me(skipRedirect = false): Promise<User> {
    const res = await apiFetch(`/api/auth/me`, { skipRedirect });
    if (!res.ok) throw new Error('Not authenticated');
    const data = await res.json();
    return data.data as User;
  }
}


